function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgModDtfMeterSheet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 53.534 36.484"
    },
    viewBox: "0 0 53.534 36.484",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M39.657 34.852c-.254.36-.657.584-1.097.599-4.436.149-9.582-.255-13.672-1.598a10.363 10.363 0 0 1-4.227-2.625c-1.64-1.683-2.575-4.498-2.993-6.825-.377-2.099-1.445-3.954-3.016-5.369-2.725-2.258-5.919-2.906-9.353-1.663-.038.014-1.114 1.077-1.087 1.048l8.86-9.379 2.919-3.087c1.227-1.297 2.377-2.594 3.674-3.818 1.345-1.27 3.374-1.4 5.03-.732 2.592 1.046 4.347 3.981 4.812 6.639.179 1.024.956 2.493 1.7 3.218 1.485 1.449 3.535 2.095 5.564 2.701a61.93 61.93 0 0 0 7.347 1.508c2.694.389 5.353.655 8.089.743.28.009.439.322.277.55l-7.757 10.925-5.07 7.165z",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.078,
    cy: 25.028,
    r: 8.118,
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.078,
    cy: 25.028,
    r: 4.483,
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.293 27.542-1.273.009c-.151.001-.266.013-.429-.005l-.91 2.379-1.003-2.558-2.643-.415 2.051-1.453-.674-2.565 2.234 1.63 2.177-1.253-.649 2.437 1.988 1.769-.552.059-.317-.034zm6.386 5.391-1.431-2.317-2.709.234 1.802-1.952-1.093-2.398 2.469 1.079 1.93-1.749-.206 2.593 2.327 1.345-2.585.563zm3.997-6.761c-.544.025-1.09-.124-1.449-.479l-.893-.881c-.536-.66-.947-1.362-1.359-2.144l2.595-.272c.603-.063 1.198.06 1.779.195.763.246 1.265.904 1.207 1.739-.066.97-.868 1.797-1.88 1.842zm-6.824-3.771c-.655.773-1.685.879-2.504.345-1.079-.704-1.649-2.318-2.113-3.568l-.118-.404c1.112.127 2.125.26 3.178.53.619.159 1.199.399 1.603.908.5.628.486 1.561-.046 2.189zm12.03-2.561c-1.477.586-4.638 1.549-5.41.221-.184-.317-.072-.684.142-.944.314-.382.73-.541 1.276-.594-.404-.451-.384-1.035.062-1.379.575-.443 1.339-.421 1.944-.027.936.61 1.498 1.692 1.986 2.723zm-23.085 1.249-.706 1.945-.804-2.333-2.098-.652 1.609-1.035-.536-2.202 1.773 1.563 1.632-.825-.457 2.037 1.616 1.854zm12.342-2.683c-1.046.146-2.991-.192-2.935-1.277.03-.594.748-.913 1.504-.883-.276-.461-.172-1.021.292-1.256.595-.301 1.237-.151 1.716.305.344.327.656.721.833 1.176l.641 1.65-2.051.285zm-7.615-2.056c-.174.59-.62 1.02-1.093 1.127-1.232.279-2.04-.849-2.342-2.06-.217-.87-.352-1.695-.491-2.64l1.677.622c.527.195 1.013.486 1.464.814.671.487 1.025 1.321.785 2.137zm2.531-2.968c-1.323-.268-2.727-.521-3.709-1.509-.3-.381-.474-.873-.224-1.302.301-.518.914-.541 1.444-.24-.235-.559-.047-1.15.502-1.279.466-.109.851.153 1.169.49.713 1.052.762 2.5.818 3.84zM15.16 15.237l-2.31.331 1.416-1.388-1.004-1.505 2.174.52 1.625-1.203-.116 1.62 2.018.804-2.176.543-.341 1.738zm6.366-4.095c-.582.75-1.604.822-2.362.3-.706-.486-1.379-1.779-1.729-2.692 1.393-.015 3.935-.18 4.314 1.197.114.414.055.838-.223 1.195zm3.476-3.716c-1.413.218-4.68.322-4.723-.92-.022-.628.674-.887 1.43-.908-.059-.202-.124-.607-.011-.794.315-.52.886-.565 1.435-.438 1.098.568 1.472 1.795 1.869 3.06z",
    style: {
      fill: "#222"
    }
  }));
};
export default SvgModDtfMeterSheet;